module.exports = __webpack_public_path__ + "img/exclemation-mark-coral.d2ff86c0.svg";